// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","shadeDisabled":"rgb(205, 204, 204)","colorPrimaryOrange":"#e16e46","container":"progress-bar__container____3nuA7","bar":"progress-bar__bar____2Z3PO","background":"progress-bar__background____2jjF9 progress-bar__bar____2Z3PO","progress":"progress-bar__progress____2L_6U progress-bar__bar____2Z3PO","progressTip":"progress-bar__progressTip____1_xms"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/progress-bar/progress-bar.css
// module id = 544
// module chunks = 0